import '../web-components/loaders/claim-row-loader';

export const surepart = `
<div style="display:flex;gap:1.25rem;flex-direction:column;margin: 0 1.5rem">
    <!-- Header -->
    <div style="display:flex;align-items:center;justify-content:space-between;margin-top:1.25rem">
        <div class="react-loading-skeleton" style="width:86px;height:36px"></div>
        <div style="display:flex;gap:0.5rem;align-items:center">
            <div class="react-loading-skeleton" style="width:44px;height:24px"></div>
            <div class="react-loading-skeleton" style="width:75px;height:20px"></div>
        </div>
    </div>

    <!-- Body -->
    <div
        style="background-color:white;border-radius:0.25rem;display:grid;grid-template-columns:0.8fr 68px 1fr 60px 160px 178px 120px">
        <!-- Header Row -->
        <div
            style="grid-column:1 / -1;display:grid;grid-template-columns:subgrid;background-color:#1D70D0;height:48px;border-top-left-radius:0.25rem;border-top-right-radius:0.25rem">
            <!-- Claim -->
            <div class="react-loading-skeleton" style="width:36px;height:20px;margin:auto;margin-left:0.75rem"></div>
            <!-- Insurer -->
            <div class="react-loading-skeleton" style="width:44px;height:20px;margin:auto;margin-left:0.75rem"></div>
            <!-- Vehicle -->
            <div class="react-loading-skeleton" style="width:46px;height:20px;margin:auto;margin-left:0.75rem"></div>
            <!-- Parts -->
            <div class="react-loading-skeleton" style="width:34px;height:20px;margin:auto;margin-left:0.75rem"></div>
            <!-- Customer -->
            <div class="react-loading-skeleton" style="width:60px;height:20px;margin:auto;margin-left:0.75rem"></div>
            <!-- Created -->
            <div class="react-loading-skeleton" style="width:48px;height:20px;margin:auto;margin-left:0.75rem"></div>
        </div>

        <!-- Body Rows -->
        <claim-row-loader></claim-row-loader>
        <claim-row-loader></claim-row-loader>
        <claim-row-loader></claim-row-loader>
        <claim-row-loader></claim-row-loader>
        <claim-row-loader></claim-row-loader>
        <claim-row-loader></claim-row-loader>
        <claim-row-loader></claim-row-loader>
        <claim-row-loader></claim-row-loader>
        <claim-row-loader></claim-row-loader>
        <claim-row-loader></claim-row-loader>
    </div>

    <!-- Footer -->
    <div style="display:flex;align-items:center;justify-content:space-between">
        <div style="display:flex;gap:1.25rem;align-items:center">
            <div class="react-loading-skeleton" style="width:117px;height:19px"></div>
            <div class="react-loading-skeleton" style="width:65px;height:40px"></div>
        </div>
        <div class="react-loading-skeleton" style="width:230px;height:38px"></div>
    </div>
</div>`;
